import React from 'react';
import styles from './styles.module.scss';

type SeccionProps = {
    children?: React.ReactNode
    style?: React.CSSProperties
    color?: string
    padding?: string
    paddingMobile?: string
    borderRadius?: string
}

const Seccion = ({ children, style, color, padding, paddingMobile, borderRadius }: SeccionProps) => {
  return (
    <div
      className={styles.seccion}
      style={{
        backgroundColor: color ?? '#fff',
        borderRadius: borderRadius ?? '0px',
        '--seccion-padding': padding ?? '60px 12px',
        '--seccion-padding-mobile': paddingMobile ?? padding ?? '60px 12px',
        ...style,
      } as React.CSSProperties}
    >
      {children}
    </div>
  );
};

export default Seccion;
